'use client';

import { useEffect } from 'react';

export function SmoothScroll() {
  useEffect(() => {
    // Function to handle smooth scrolling for hash links
    const handleHashLinkClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const link = target.closest('a');
      
      // Check if it's a link and has a hash fragment
      if (link && link.hash && link.hash.startsWith('#')) {
        e.preventDefault();
        
        // Find the target element
        const targetId = link.hash.substring(1);
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          // Scroll smoothly to the target element
          targetElement.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
          
          // Update URL without page jump (optional)
          window.history.pushState(null, '', link.hash);
        }
      }
    };
    
    // Add event listener to the document
    document.addEventListener('click', handleHashLinkClick);
    
    // Clean up event listener on component unmount
    return () => {
      document.removeEventListener('click', handleHashLinkClick);
    };
  }, []);
  
  // This component doesn't render anything
  return null;
}

export default SmoothScroll; 